<template>
	<div>
        <div class="margin-top-20">
            <section class="margin-bottom-10" v-if="valueAdded.indexOf(1) >= 0">
                <vFormItem class="margin-bottom-5" label="产品标/ItemLabel(PDF,JPG,PNG)" required prop="ItemLabel"></vFormItem>
                <div class="margin-bottom-10" >
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'ItemLabel')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click=" showAttach = true; fileType = 'ItemLabel'">
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
            <section class="margin-bottom-10">
                <vFormItem class="margin-bottom-5" label="其他附件/Other（xlsx,xls,doc,docx,PDF,PNG,JPEG,JPG,ZIP,RAR）" ></vFormItem>
                <div class="margin-bottom-10">
                    <span v-for="(item,index) in dataList.filter( item => item.attachType == 'Other')" :key="index" class="margin-right-10" style="background:#f0f2f5; padding: 0 8px; border-radius: 4px;font-weight: 400">
                        <Tooltip placement="top">
                            <div slot="content">
                                {{item.filename}}
                            </div>
                            <a @click="downloadFile(item)">
                                {{item.filename.length > 20 ? item.filename.slice(0,20).concat('...') : item.filename || "-"}}
                            </a>
                        </Tooltip>
                        <b class="margin-left-10" @click="removeItems(item)" style="cursor:pointer;">×</b>
                    </span>
                </div>
                <vButton @click="showAttach=true;fileType='Other'" >
                    <Icon type="ios-cloud-upload" size="16" style="color: black; margin-top: 3px; margin-right: 5px"></Icon>
                    <span>Upload Files</span>
                </vButton>
            </section>
        </div>
		<vModal v-model="showAttach" :title="$t('global.common.import',{defaultValue:'导入数据'})" :showFooter="false">
			<compMutiUpload v-bind="getFileProps" @on-cancel="cancelUpload" @on-success="handleAttach" />
		</vModal>
        <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false" @on-confirm="modalProps.show=false">
			<component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" @on-close="modalProps.show=false" v-on="modalProps.on"/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpMarkChangeDeleteAttach } from "@/service/misc";

export default {
	props: ['data', 'status','activeid', 'isLabel'],
	components: {
		compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
	},
	data() {
		return {
			type: this.$route.params.type,
			id: this.$route.query.id || "",
			showAttach: false,
			fileType: 'Other',
			loading: false,
			dataList: this.data || [],
			valueAdded: [],
            modalProps: {
				show: false,
				formdata: null,
			},
		}
	},
	created() {
		if(this.activeid){
			this.id = this.activeid
		}
	},
	watch: {
		data(val) {
			this.dataList = val || [];
		},
        isLabel(val) {
            this.valueAdded = val;
        }
	},
	computed: {
		getFileProps() {
			return {
                action: process.env.VUE_APP_APIURL_FBB + '/api/v2/changeLabelPlan/attachmentUpload',
				name: "multipartFile",
				data: {
                    attachType: this.fileType,
                    id: this.id,
				},
                multiple: true,
                formatter: (res) => {
                    this.$VMessage.success(res.message);
                    this.handleAttach(res.data)
                    return res.data;
                },
				accept: this.fileType === 'Other' ? '' : 'image/*,application/pdf'
			}
		},
	},
	methods: {
		handleAttach(res) {
			this.dataList.push(res);
            this.update();
			this.cancelUpload();
		},
        cancelUpload() {
            this.showAttach = false;
        },
        downloadFile(item){
            this.handleWebfs(item.fileurl, {}, 'download')
        },
		removeItems(obj) {
            this.modalProps = {
				show: true,
				title: "删除附件",
				alert: "error",
                desc: this.$t('fbb.markchange.deletemark', { defaultValue: '附件删除不可恢复，是否确认？' }),
				showDesc: true,
				params: { attachmentIds: obj.id },
				ajaxRequest: HttpMarkChangeDeleteAttach,
                callback:(res)=>{
                    this.$VMessage.success(res.message);
                    const index = this.dataList.findIndex( item=> item.id === obj.id);
                    this.dataList.splice(index,1)
                    this.update();
                }
			};
		},
        update(){
            this.$emit('on-update', this.dataList)
        }
	}
}
</script>
